const actions = {
  GET_INTRODUCERS: 'GET_INTRODUCERS',
  GET_INTRODUCERS_SUCCESS: 'GET_INTRODUCERS_SUCCESS',
  GET_INTRODUCERS_FAILURE: 'GET_INTRODUCERS_FAILURE',

  GET_MERCHANTS: 'GET_MERCHANTS',
  GET_MERCHANTS_SUCCESS: 'GET_MERCHANTS_SUCCESS',
  GET_MERCHANTS_FAILURE: 'GET_MERCHANTS_FAILURE',

  GET_CLIENTS: 'GET_CLIENTS',
  GET_CLIENTS_SUCCESS: 'GET_CLIENTS_SUCCESS',
  GET_CLIENTS_FAILURE: 'GET_CLIENTS_FAILURE',

  GET_CURRENCIES: 'GET_CURRENCIES',
  GET_CURRENCIES_SUCCESS: 'GET_CURRENCIES_SUCCESS',
  GET_CURRENCIES_FAILURE: 'GET_CURRENCIES_FAILURE',

  GET_COUNTRIES: 'GET_COUNTRIES',
  GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
  GET_COUNTRIES_FAILURE: 'GET_COUNTRIES_FAILURE',

  // RC - Restricted Currencies
  GET_RC_CURRENCIES: 'GET_RC_CURRENCIES',
  GET_RC_CURRENCIES_SUCCESS: 'GET_RC_CURRENCIES_SUCCESS',
  GET_RC_CURRENCIES_FAILURE: 'GET_RC_CURRENCIES_FAILURE',

  GET_INTRODUCERS_CLIENTS: 'GET_INTRODUCERS_CLIENTS',
  GET_INTRODUCERS_CLIENTS_SUCCESS: 'GET_INTRODUCERS_CLIENTS_SUCCESS',
  GET_INTRODUCERS_CLIENTS_FAILURE: 'GET_INTRODUCERS_CLIENTS_FAILURE',

  GET_MERCHANTS_CLIENTS: 'GET_MERCHANTS_CLIENTS',
  GET_MERCHANTS_CLIENTS_SUCCESS: 'GET_MERCHANTS_CLIENTS_SUCCESS',
  GET_MERCHANTS_CLIENTS_FAILURE: 'GET_MERCHANTS_CLIENTS_FAILURE',

  GET_CURRENCIES_BY_ACCOUNT_ID: 'GET_CURRENCIES_BY_ACCOUNT_ID',
  GET_CURRENCIES_BY_ACCOUNT_ID_SUCCESS: 'GET_CURRENCIES_BY_ACCOUNT_ID_SUCCESS',
  GET_CURRENCIES_BY_ACCOUNT_ID_FAILURE: 'GET_CURRENCIES_BY_ACCOUNT_ID_FAILURE',

  GET_CLIENT_BY_ID_DEPRECATED: 'GET_CLIENT_BY_ID_DEPRECATED',

  GET_CLIENT_BY_ID: 'GET_CLIENT_BY_ID',
  GET_CLIENT_BY_ID_SUCCESS: 'GET_CLIENT_BY_ID_SUCCESS',
  GET_CLIENT_BY_ID_FAILURE: 'GET_CLIENT_BY_ID_FAILURE',

  GET_CLIENT_PARTNER_BY_PARENT_ID: 'GET_CLIENT_PARTNER_BY_PARENT_ID',
  GET_CLIENT_PARTNER_BY_PARENT_ID_SUCCESS: 'GET_CLIENT_PARTNER_BY_PARENT_ID_SUCCESS',
  GET_CLIENT_PARTNER_BY_PARENT_ID_FAILURE: 'GET_CLIENT_PARTNER_BY_PARENT_ID_FAILURE',

  // GET_STREAMING_CHANNELES: 'GET_STREAMING_CHANNELES',
  // GET_STREAMING_CHANNELES_SUCCESS: 'GET_STREAMING_CHANNELES_SUCCESS',
  // GET_STREAMING_CHANNELES_FAILURE: 'GET_STREAMING_CHANNELES_FAILURE',
}
export default actions

// export const getStreamingChannels = token => {
//   return {
//     type: actions.GET_STREAMING_CHANNELES,
//     token,
//   }
// }

export const getIntroducers = token => {
  return {
    type: actions.GET_INTRODUCERS,
    token,
  }
}

export const getMerchants = token => {
  return {
    type: actions.GET_MERCHANTS,
    token,
  }
}

export const getClientPartners = (parentId, token) => {
  return {
    type: actions.GET_CLIENT_PARTNER_BY_PARENT_ID,
    payload: { parentId, token },
  }
}

export const getClients = token => {
  return {
    type: actions.GET_CLIENTS,
    token,
  }
}

export const getClientById = (clientId, token) => {
  return {
    type: actions.GET_CLIENT_BY_ID,
    payload: { clientId, token },
  }
}

export const newGetClientById = (clientId, token) => {
  return {
    type: actions.NEW_GET_CLIENT_BY_ID,
    payload: { clientId, token },
  }
}

export const getIntroducerClients = (value, token) => {
  return {
    type: actions.GET_INTRODUCERS_CLIENTS,
    value,
    token,
  }
}

export const getMerchantClients = (value, token) => {
  return {
    type: actions.GET_MERCHANTS_CLIENTS,
    value,
    token,
  }
}

export const getCurrencies = token => {
  return {
    type: actions.GET_RC_CURRENCIES,
    token,
  }
}

export const getAllCurrencies = token => {
  return {
    type: actions.GET_CURRENCIES,
    token,
  }
}

export const getAllCountries = token => {
  return {
    type: actions.GET_COUNTRIES,
    token,
  }
}

export const getCurrenciesByAccountId = (accountId, token) => {
  return {
    type: actions.GET_CURRENCIES_BY_ACCOUNT_ID,
    accountId,
    token,
  }
}
